export const THEMES = {
  light: {
    bg: '#ffffff',
    surface: '#f9fafb',
    card: '#ffffff',
    text: '#111827',
    textSecondary: '#6b7280',
    border: '#e5e7eb',
    primary: '#0ea5e9',
    primaryHover: '#0284c7',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    inputBg: '#ffffff',
    inputBorder: '#d1d5db',
  },
  dark: {
    bg: '#111827',
    surface: '#1f2937',
    card: '#1f2937',
    text: '#f9fafb',
    textSecondary: '#9ca3af',
    border: '#374151',
    primary: '#0ea5e9',
    primaryHover: '#38bdf8',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    inputBg: '#1f2937',
    inputBorder: '#4b5563',
  },
};

export const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};
